import { render, staticRenderFns } from "./AdminResearches.vue?vue&type=template&id=e574a70a&"
import script from "./AdminResearches.vue?vue&type=script&lang=js&"
export * from "./AdminResearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports